import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'shipment-select-btn-cell-renderer',
  template: `
    <button 
    style="
    height: 35px;
    outline: none;
    border: 1 solid;
    border-radius : 2px;
    padding: 0 14px;
    text-transform: uppercase;
    color: black;
    background: linear-gradient(180deg, #FFFFFF 0%, #E9F0F3 100%)"
    (click)="btnClickedHandler($event)" class="vpacs-btn-table">Select</button>
  `,
})

export class ShipmentSelectBtnCellRender implements ICellRendererAngularComp {

  constructor(private readonly router: Router, private readonly route: ActivatedRoute, ){}
  refresh(params: ICellRendererParams): boolean {
    throw new Error(`Error while refreshing renderer component. INFO - ${JSON.stringify(params)}`);
  }

  private params: any;
  agInit(params: any): void {
    this.params = params;    
  }
  btnClickedHandler(_event: any) {
    this.params.clicked(this.params.data);
  }
}

